// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + "actioncable" + "-" + "2ec8bbbaffa61359ecc6" + ".chunk.js";
};